import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export const REACTIONS = ["👍", "❤️", "🚀", "🔥", "👀"];

/** Compact 5-emoji reaction bar. `reactions` is `{emoji: [user_id, ...]}`.
 *  Calls onChange(newReactions) on toggle. Optimistic; rolls back on error. */
export default function ReactionBar({ cid, mid, reactions, currentUserId, onChange, disabled }) {
  const [busy, setBusy] = useState(false);

  const toggle = async (emoji) => {
    if (busy || disabled) return;
    if (!currentUserId) { toast.error("LOG IN TO REACT"); return; }
    setBusy(true);
    // Optimistic
    const prev = { ...(reactions || {}) };
    const next = { ...(reactions || {}) };
    const list = new Set(next[emoji] || []);
    if (list.has(currentUserId)) list.delete(currentUserId);
    else list.add(currentUserId);
    if (list.size) next[emoji] = [...list];
    else delete next[emoji];
    onChange && onChange(next);
    try {
      const r = await api.post(`/communities/${cid}/messages/${mid}/react`, { emoji });
      onChange && onChange(r.data.reactions || {});
    } catch (err) {
      onChange && onChange(prev);
      toast.error(err?.response?.data?.detail || "REACT FAILED");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-1" data-testid={`reactions-${mid}`}>
      {REACTIONS.map(em => {
        const users = (reactions && reactions[em]) || [];
        const mine = currentUserId && users.includes(currentUserId);
        const count = users.length;
        return (
          <button
            key={em}
            type="button"
            data-testid={`react-${mid}-${em}`}
            onClick={() => toggle(em)}
            disabled={disabled}
            className={`px-1.5 py-0.5 border font-mono text-[11px] leading-none flex items-center gap-1 transition-colors disabled:opacity-40 ${
              mine
                ? "border-[color:var(--sat-cyan)] sat-cyan"
                : "border-[color:var(--sat-border)] text-[color:var(--sat-text-dim)] hover:border-[color:var(--sat-cyan)] hover:sat-cyan"
            }`}
          >
            <span className="text-[13px] leading-none">{em}</span>
            {count > 0 && <span>{count}</span>}
          </button>
        );
      })}
    </div>
  );
}
